export const GET_CHILD_FUNDING_CALCULATOR = 'CHILD/GET_CHILD_FUNDING_CALCULATOR'
export const GET_CHILD_FUNDING_CALCULATOR_SUCCESS = 'CHILD/GET_CHILD_FUNDING_CALCULATOR_SUCCESS'
export const GET_CHILD_FUNDING_CALCULATOR_FAILED = 'CHILD/GET_CHILD_FUNDING_CALCULATOR_FAILED'
